(() => {
  const bar = document.getElementById('trr-live-bar');
  const names = document.getElementById('trr-live-names');
  const closeButton = document.getElementById('trr-live-close');

  if (!bar || !names || !closeButton) return;

  const workerURL = bar.dataset.workerUrl;
  const cacheKey = 'trrLiveCache.v2';
  const dismissedKey = 'trrLiveDismissed';
  const cacheTTL = 60 * 1000;
  const pollInterval = 120 * 1000;
  const requestTimeout = 8000;
  const debugParam = 'trrtest';
  const channel = 'BroadcastChannel' in window ? new BroadcastChannel('trrLive') : null;

  const trustedPlatforms = new Map([
    ['twitch', { name: 'Twitch', url: 'https://www.twitch.tv/TheRushRoom', order: 0 }],
    [
      'youtube',
      {
        name: 'YouTube',
        url: 'https://www.youtube.com/channel/UC3KBjDlu1KfdJIcocKGyjgg/live',
        order: 1,
      },
    ],
    ['kick', { name: 'Kick', url: 'https://kick.com/TheRushRoom', order: 2 }],
  ]);

  let requestInProgress = false;

  function readCache() {
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (!cached || !Number.isFinite(cached.ts) || typeof cached.data !== 'object') return null;
      return cached;
    } catch (_error) {
      return null;
    }
  }

  function isDismissed() {
    try {
      return sessionStorage.getItem(dismissedKey) === '1';
    } catch (_error) {
      return false;
    }
  }

  function writeCache(data) {
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), data }));
    } catch (_error) {
      // Storage may be unavailable in private browsing. The live bar can still work.
    }

    channel?.postMessage({ type: 'update', data });
  }

  function normalizePlatforms(data) {
    if (!data || data.live !== true || !Array.isArray(data.platforms)) return [];

    const seen = new Set();
    const platforms = [];

    data.platforms.forEach((platform) => {
      if (!platform || platform.live !== true || typeof platform.name !== 'string') return;

      const key = platform.name.trim().toLowerCase();
      const trusted = trustedPlatforms.get(key);
      if (!trusted || seen.has(key)) return;

      seen.add(key);
      platforms.push(trusted);
    });

    return platforms.sort((a, b) => a.order - b.order);
  }

  function updatePageOffset() {
    if (bar.hidden) {
      document.body.classList.remove('trr-live-bar-visible');
      document.body.style.removeProperty('--trr-live-bar-height');
      return;
    }

    document.body.style.setProperty('--trr-live-bar-height', `${bar.offsetHeight}px`);
    document.body.classList.add('trr-live-bar-visible');
  }

  function hideBar() {
    bar.hidden = true;
    updatePageOffset();
  }

  function renderPlatformLinks(platforms) {
    names.replaceChildren();

    platforms.forEach((platform, index) => {
      if (index > 0) {
        const separator = index === platforms.length - 1 ? ' and ' : ', ';
        names.append(document.createTextNode(separator));
      }

      const link = document.createElement('a');
      link.href = platform.url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = platform.name;
      names.append(link);
    });
  }

  function render(data) {
    if (isDismissed()) {
      hideBar();
      return;
    }

    const platforms = normalizePlatforms(data);
    if (platforms.length === 0) {
      hideBar();
      return;
    }

    renderPlatformLinks(platforms);
    bar.hidden = false;
    requestAnimationFrame(updatePageOffset);
  }

  async function fetchStatus() {
    if (!workerURL) throw new Error('Live-status endpoint is missing.');

    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), requestTimeout);

    try {
      const response = await fetch(workerURL, {
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: controller.signal,
      });

      if (!response.ok) throw new Error(`Live-status request failed with ${response.status}.`);

      const data = await response.json();
      if (!data || typeof data !== 'object' || typeof data.live !== 'boolean') {
        throw new Error('Live-status response has an invalid format.');
      }

      return data;
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function checkLive() {
    if (new URLSearchParams(window.location.search).has(debugParam)) {
      render({
        live: true,
        platforms: [
          { name: 'Twitch', live: true },
          { name: 'YouTube', live: true },
          { name: 'Kick', live: true },
        ],
      });
      return;
    }

    const cached = readCache();
    if (cached && Date.now() - cached.ts < cacheTTL) {
      render(cached.data);
      return;
    }

    if (requestInProgress) return;
    requestInProgress = true;

    try {
      const data = await fetchStatus();
      writeCache(data);
      render(data);
    } catch (error) {
      console.warn('Live check failed', error);
      if (cached) render(cached.data);
    } finally {
      requestInProgress = false;
    }
  }

  closeButton.addEventListener('click', () => {
    try {
      sessionStorage.setItem(dismissedKey, '1');
    } catch (_error) {
      // The current page still hides the bar if storage is unavailable.
    }
    hideBar();
  });

  channel?.addEventListener('message', (event) => {
    if (event.data?.type === 'update') render(event.data.data);
  });

  window.addEventListener('resize', updatePageOffset);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkLive();
  });

  checkLive();
  window.setInterval(checkLive, pollInterval);
})();
